module.exports = __webpack_public_path__ + "static/media/Monstera.895c9e83.mov";